export const titleStyles = {
  display: 'flex',
  flexDirection: 'column',
};
